import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TitanButtonComponent} from '../../../user-interface/titan-button/titan-button.component';

export interface ConfirmModalData {
  title: string,
  content: string
}

@Component({
  selector: 'app-sp-modal-confirm',
  standalone: true,
  imports: [
    TitanButtonComponent
  ],
  templateUrl: './sp-modal-confirm.component.html'
})

export class SpModalConfirmComponent implements OnInit {
  title = '';
  textContent = '';

  constructor(
    public dialogRef: MatDialogRef<SpModalConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmModalData,
  ) { }

  ngOnInit(): void {
    this.title = this.data.title;
    this.textContent = this.data.content;
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
